import { render, staticRenderFns } from "./shopInfo.vue?vue&type=template&id=0bb892da&scoped=true"
import script from "./shopInfo.vue?vue&type=script&lang=js"
export * from "./shopInfo.vue?vue&type=script&lang=js"
import style0 from "./shopInfo.vue?vue&type=style&index=0&id=0bb892da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb892da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb892da')) {
      api.createRecord('0bb892da', component.options)
    } else {
      api.reload('0bb892da', component.options)
    }
    module.hot.accept("./shopInfo.vue?vue&type=template&id=0bb892da&scoped=true", function () {
      api.rerender('0bb892da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/children/shopInfo.vue"
export default component.exports